import { render, staticRenderFns } from "./MentionBox.vue?vue&type=template&id=da2cf3d8&scoped=true&"
import script from "./MentionBox.vue?vue&type=script&setup=true&lang=js&"
export * from "./MentionBox.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MentionBox.vue?vue&type=style&index=0&id=da2cf3d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2cf3d8",
  null
  
)

export default component.exports